import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from '@cbridge-utils/react-redux';
import { AutocompleteFieldControl, SelectFieldControl, TextFieldControl } from '@cbridge-tools/field';
import { IStreamForm } from '@cbridge-packages/stream';
import { streamFormPropsSelector } from './StreamForm.selector';

export const StreamForm: FunctionComponent = () => {
  const { t } = useTranslation();

  const { nodeList, markupProfiles } = useSelector(streamFormPropsSelector);

  return (
    <Grid container={true} rowSpacing={2} columnSpacing={2}>
      <Grid size={12}>
        <TextFieldControl<IStreamForm, 'name'>
          label={t('text:entity.markupStream.name.label')}
          name={'name'}
          required={true}
          tooltip={t('text:entity.markupStream.name.tooltip')}
        />
      </Grid>

      <Grid size={12}>
        <SelectFieldControl<IStreamForm, 'nodeId'>
          label={t('text:entity.symbolPool.nodeName.label')}
          name={'nodeId'}
          forceDisabled={true}
          tooltip={t('text:entity.symbolPool.nodeName.tooltip')}
        >
          {nodeList.map(({ nodeId, name }) => (
            <MenuItem key={nodeId} value={nodeId}>
              {name}
            </MenuItem>
          ))}
        </SelectFieldControl>
      </Grid>

      <Grid size={12}>
        <AutocompleteFieldControl<IStreamForm>
          label={t('text:entity.markupProfile.name.label')}
          name={'markupProfileId'}
          tooltip={t('text:entity.markupProfile.name.tooltip')}
          options={markupProfiles}
          placeholder={t('text:rulesEditor.placeholder.defaultProfile')}
          freeSolo={false}
        />
      </Grid>
    </Grid>
  );
};
